import { Scorecard } from '@/components/Score/Scorecard';
import { ScoreData } from '../ScoreRowCard.types';
import { scoreRowCardStyles } from '../ScoreRowCard.styles';
import React from 'react';

/** Props for the ScoreRowCardScoreDisplay component */
export interface ScoreRowCardScoreDisplayProps {
  /** Whether the score data is still loading */
  isLoading?: boolean;
  /** Score data including value, maxValue, and type */
  score: ScoreData;
  /** ScoreCard ID, required for sharing functionality */
  scoreCardId?: number;
  /** Session ID, required for sharing functionality */
  sessionId?: number;
  /** Whether this score has already been shared with the manager */
  sharedWithManager?: boolean;
  /** User ID associated with this score */
  userId?: string;
  /** Visual variant of the scorecard */
  variant: 'violation' | 'pass' | 'fail' | 'simple';
}

/**
 * Renders the scorecard display section of a ScoreRowCard.
 */
export const ScoreRowCardScoreDisplay: React.FC<ScoreRowCardScoreDisplayProps> = ({
  isLoading,
  score,
  scoreCardId,
  sessionId,
  sharedWithManager,
  userId,
  variant,
}) => (
  <div className={scoreRowCardStyles.scoreContainer}>
    <Scorecard
      isLoading={isLoading}
      maxScore={score?.maxValue}
      score={score?.value}
      scorePercentage={score?.percentageValue}
      sessionId={sessionId}
      scoreCardId={scoreCardId}
      sharedWithManager={sharedWithManager}
      userId={userId}
      variant={variant}
    />
  </div>
);

ScoreRowCardScoreDisplay.displayName = 'ScoreRowCardScoreDisplay';

export default ScoreRowCardScoreDisplay;
